import { createElement, useCallback, useState, useEffect } from 'react';
import { Input, Icon, Balloon, DatePicker2 } from '@alifd/next';
const DateRangeFilter = ({ onChange, name, fieldName }) => {
    const [date, setDate] = useState([]);
    useEffect(() => {
        setDate([
            {
                operator: '>=',
                dataType: 'date',
                value: null,
                name,
                fieldName,
            },
            {
                operator: '<=',
                dataType: 'date',
                value: null,
                name,
                fieldName,
            },
        ]);
    }, [fieldName, name]);
    const [dateStr, setDateStr] = useState();
    const innerAfterChange = useCallback((value, operator) => {
        if (operator === '>=') {
            date[0].value = value;
        }
        else {
            date[1].value = value;
        }
        onChange(date);
        setDate(date);
        setDateStr(renderDate(date));
        console.log('Dogtiti ~ file: date-range-filter.tsx ~ line 51 ~ date', date);
    }, [date, onChange]);
    const renderDate = (date) => {
        const [start, end] = date;
        let dateStr;
        if (start?.value && end?.value) {
            dateStr = `${start?.value} ~ ${end?.value}`;
        }
        else if (start?.value) {
            dateStr = `>= ${start?.value}`;
        }
        else if (end?.value) {
            dateStr = `<= ${end?.value}`;
        }
        return dateStr;
    };
    return (createElement(Input, { value: dateStr, className: "filter-input", trim: true, hasClear: true, innerAfter: createElement(InnerAfter, { onChange: innerAfterChange }), readOnly: true }));
};
const InnerAfter = ({ onChange }) => {
    return (createElement(Balloon, { v2: true, align: "b", closable: false, arrowPointToCenter: true, triggerType: "click", trigger: createElement(Icon, { type: "calendar", size: "xs", style: { margin: 4, cursor: 'pointer', color: '#999' } }), cache: true },
        createElement("div", { style: { display: 'flex', flexDirection: 'column', rowGap: 4 } },
            createElement(DatePicker2, { onChange: (value) => onChange(value, '>='), followTrigger: true, placeholder: ">=", outputFormat: "YYYY-MM-DD" }),
            createElement(DatePicker2, { onChange: (value) => onChange(value, '<='), followTrigger: true, placeholder: "<=", outputFormat: "YYYY-MM-DD" }))));
};
export default DateRangeFilter;
